import React, { useEffect, useState } from 'react';
import CategoriasCabecera from './CategoriasCabecera';
import CategoriaDesplegada from './CategoriaDesplegada';
import axios from 'axios';
import clienteAxios from '../../helpers/axios.helper';

function Categorias({ categoriaDesplegada, setCategoriaDesplegada, menuAbierto, setCategoriaDesplegadaRes, categoriaDesplegadaRes, setMenuAbierto }) {
  const [categoria, setCategoria] = useState('');
  const [categoriaSeleccionada, setCategoriaSeleccionada] = useState(null);
  const [categoriasArray, setCategoriasArray] = useState([]);
  const [desplegar, setDesplegar] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Llamada a la API para obtener las categorías
    const fetchCategorias = async () => {
      try {
        setLoading(true);
        const response = await clienteAxios('/categorias'); // Cambia esto por la URL de tu API
    
        if (response.data?.length > 0) {
          setCategoriasArray(response.data);
          setCategoriaSeleccionada(response.data[0]); 
        } else {
          setCategoriasArray([]); // Asegúrate de que quede vacío si no hay categorías
        }
      } catch (err) {
        setError(err.message || 'Error desconocido');
      } finally {
        setLoading(false);
      }
    };
    fetchCategorias();
  }, []);

  useEffect(() => {
    setCategoria(categoriaSeleccionada);
  }, [categoriaSeleccionada]);

  if (loading) {
    return <p className="text-center text-gray-500 mt-10">Cargando categorías...</p>;
  }

  if (error) {
    return <p className="text-center text-red-500 mt-10">Error: {error}</p>;
  }

  if (categoriasArray.length === 0) {
    return <p className="text-center text-gray-500 mt-10">No hay categorías disponibles. Por favor, contacte al administrador.</p>;
  }

  return (
    menuAbierto && categoriaDesplegadaRes ? (
      <div
        className={`fixed w-2/3 overflow-auto top-24 left-0 h-full bg-white transition-transform duration-300 ease-in-out z-50 ${
          categoriaDesplegada ? 'translate-x-0' : '-translate-x-full'
        }`}
      >
        <CategoriasCabecera
          setDesplegar={setDesplegar}
          menuAbierto={menuAbierto}
          categoriasArray={categoriasArray}
          categoriaSeleccionada={categoriaSeleccionada}
          setCategoriaSeleccionada={setCategoriaSeleccionada}
        />
        {desplegar ? (
          <div className="w-full min-h-screen h-full flex overflow-scroll">
            {categoriaSeleccionada?.subcategorias.map((sc, index) => (
              <CategoriaDesplegada
                key={index}
                setMenuAbierto={setMenuAbierto}
                desplegar={desplegar}
                subcategoria={sc}
                categoria={categoria}
                setCategoriaDesplegada={setCategoriaDesplegada}
              />
            ))}
          </div>
        ) : null}
      </div>
    ) : (
      <div
        className={`${
          categoriaDesplegada ? 'opacity-100 h-96' : 'opacity-0 h-0'
        } hidden md:flex md:flex-col md:overflow-hidden md:w-screen md:transition-all md:duration-500 md:ease-in-out`}
      >
        <CategoriasCabecera
          categoriasArray={categoriasArray}
          categoriaSeleccionada={categoriaSeleccionada}
          setCategoriaSeleccionada={setCategoriaSeleccionada}
        />
        <div className="w-full h-full flex flex-wrap justify-center overflow-scroll">
          {categoriaSeleccionada?.subcategorias.map((sc, index) => (
            <CategoriaDesplegada
              key={index}
              subcategoria={sc}
              categoria={categoria}
              setCategoriaDesplegada={setCategoriaDesplegada}
            />
          ))}
        </div>
      </div>
    )
  );
}

export default Categorias;
